export default __webpack_public_path__ + "static/media/forestly-expl-nn-04_DE.369642cf.png";